import { Button, styled } from "@mui/material";

export const IconButton = styled(Button)`
  min-width: min-content;
  padding: 0.25em;
  font-size: 1em;
`;
